import { BaseRouteService } from 'core/services';

class ReceivingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'receivings/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default ReceivingRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ReceivingRouteService.js